import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { ReusableAttachmentService } from 'app/global/reusable-attachment.service';
import { Block } from 'app/interfaces/blocks';
import { MetaDataSectionEnum } from 'app/main/pages/settings/documentfields/meta-data.helper';

@Pipe({
  name: 'reusableAttachment'
})
export class ReusableAttachmentPipe implements PipeTransform {

  constructor(
    private globalService: GlobalService,
    private reusableAttachmentService: ReusableAttachmentService
  ){
  }

  async transform(selectedRecipient, metaDataId: number, fieldSection: string, areaType: string, roleId: number) {
    let attachmentThumbnail = areaType === 'html' ? '&nbsp;' : '';
    if(selectedRecipient?.recipient_id){
      attachmentThumbnail = areaType === 'html' ? 'Not Available' : '';
      let notFoundInBlock = true;
      if (this.globalService?.fields_data?.['blocks']) {
        const foundAttachment = Object.values(this.globalService.fields_data['blocks']).find((item: Block) => item.type === 'attachment' && item.meta_data_id === metaDataId && item.role_id === roleId) as Block;
        if (foundAttachment?.files && foundAttachment?.files.length > 0) {
          notFoundInBlock = false;
          if (areaType === 'html') {
            const runTimeObject = {
              file_name: foundAttachment?.attachment_name,
              value: foundAttachment?.files[0]?.url
            }
            attachmentThumbnail = await this.reusableAttachmentService.getFileThumbnail(runTimeObject, true);
          } else {
            attachmentThumbnail = foundAttachment?.attachment_name;
          }
        }
      }   
      if(notFoundInBlock){
        let attachment;
        if(fieldSection === MetaDataSectionEnum.PERSON_FIELD && selectedRecipient?.recipient?.custom_fields){
          attachment = selectedRecipient.recipient.custom_fields.find(obj => obj.meta_data_id === metaDataId);
        } 
        else if(fieldSection === MetaDataSectionEnum.ORGANIZATION_FIELD && selectedRecipient?.organization_id && selectedRecipient?.organization?.custom_fields){
          attachment = selectedRecipient.organization.custom_fields.find(obj => obj.meta_data_id === metaDataId);
        }
        if(attachment){
          if(areaType === 'html'){
            attachmentThumbnail = await this.reusableAttachmentService.getFileThumbnail(attachment);
          } else {
            attachmentThumbnail = attachment?.file_name;
          }
        }
      }
    }
    return attachmentThumbnail;
  }
}
